<p-toast-inpage *ngIf="isRenouvellementMessageVisible" title="Avertissement">
  Le renouvellement automatique des crédits n'est pas activé sur votre compte.
</p-toast-inpage>

<p-toast-inpage title="Information" [closable]="false">
  N'étant pas gestionnaire du compte, pour passer commande vous devez :
  <br /><br />
  <ul>
    <li class="mb-1">
      Demander au responsable de votre organisme de commander en ligne pour
      vous.
    </li>
    <li>
      Ou demander au responsable de votre organisme de vous donner le droit de
      commander en ligne par simple email envoyé à
      <a href="mailto:serviceclient@adnov.fr">serviceclient&#64;adnov.fr</a>
      avec le libellé suivant : Je soussigné ... responsable de la société /
      notaire de l'office ... donne autorisation à ... pour commander des
      crédits PERVAL selon son besoin.
    </li>
  </ul>
  <p></p>
  <p>
    Pour toute question complémentaire, contacter le service client ADNOV au
    <a href="tel:0800710620">0 800 710 620</a> ou
    <a href="mailto:serviceclient@adnov.fr">serviceclient&#64;adnov.fr</a>
  </p>
</p-toast-inpage>
